import { atom } from 'jotai';

import type { ViewerTabKey } from './build-viewer-tabs';

export interface PhotoViewerTarget {
    /** Which tab to land on. Falls back to the first tab that has media. */
    tab: ViewerTabKey;
    /**
     * The media record to open on, by id — never a position. A tab sorts and
     * filters its own slides, so a caller's index is its own ordering, not the
     * viewer's; matching on identity is what keeps the tapped image and the
     * opened one the same image.
     */
    slideId: number;
}

/**
 * What the mobile photo viewer is showing, or `null` when it is closed. Lives
 * in an atom because two sections open the same viewer — the hero gallery and
 * the (02) Specs & Dimensions diagram — while it is mounted once by the page.
 */
export const photoViewerTargetAtom = atom<PhotoViewerTarget | null>(null);
